var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPauseButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 25.3333C12 26.8061 13.1939 28 14.6667 28V28C16.1394 28 17.3333 26.8061 17.3333 25.3333V14.6667C17.3333 13.1939 16.1394 12 14.6667 12V12C13.1939 12 12 13.1939 12 14.6667V25.3333ZM25.3333 12C23.8606 12 22.6667 13.1939 22.6667 14.6667V25.3333C22.6667 26.8061 23.8606 28 25.3333 28V28C26.8061 28 28 26.8061 28 25.3333V14.6667C28 13.1939 26.8061 12 25.3333 12V12Z",
    fill: "#1C1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseButton);
export default __webpack_public_path__ + "static/media/pause_button.7e9ccef07fbf20dc7fd0a9142d51e8b6.svg";
export { ForwardRef as ReactComponent };